import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
const AuthContext = createContext();
export function getUserRolesFromToken(token) {
  if (!token) return [];

  try {
    const decodedToken = jwtDecode(token);
    const roles =
      decodedToken[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];
    return Array.isArray(roles) ? roles : roles ? [roles] : [];
  } catch (error) {
    console.error("Invalid token", error);
    return [];
  }
}



function getOrganizationIdFromToken(token) {
  if (!token) return 0;

  try {
    const decodedToken = jwtDecode(token);
    // Adjust this based on your actual token structure
    return decodedToken.organizationId || 0;
  } catch (error) {
    console.error("Error decoding organizationId from token", error);
    return 0;
  }
}

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [roles, setRoles] = useState([]);
  const [organizationId, setOrganizationId] = useState(() => {
    // Initialize from localStorage
    const savedOrgId = localStorage.getItem("organizationId");
    return savedOrgId ? parseInt(savedOrgId, 10) : 0;
  });
  const [userId, setUserId] = useState(() => {
    // Initialize from localStorage
    const savedUserId = localStorage.getItem("userId");
    return savedUserId ? parseInt(savedUserId, 10) : 0;
  });
  useEffect(() => {
    const handleUserSuspended = () => {
      localStorage.setItem('suspensionMessage', "Your account has been suspended. Please contact support.");
      window.location.href = "/login";
     
    }
  
    document.addEventListener("userSuspended", handleUserSuspended);
  
    return() => {
      document.removeEventListener("userSuspended", handleUserSuspended);
    }
  }, []);

  const [emailAddress, setEmailAddress] = useState(() => {
    const savedEmailAddress = localStorage.getItem("emailAddress");
    return savedEmailAddress; 
  });
  const [firstName, setFirstName] = useState(() => {
    const savedEmailAddress = localStorage.getItem("firstName");
    return savedEmailAddress; 
  });

  const [lastName, setLastName] = useState(() => {
    const savedEmailAddress = localStorage.getItem("lastName");
    return savedEmailAddress; 
  });
  
  const [contactNumber, setContactNumber] = useState(() => {
    const savedContactNumber = localStorage.getItem("contactNumber");
    return savedContactNumber; 
  });


  const updateToken = (newToken) => {
    setToken(newToken);
    localStorage.setItem("jwtToken", newToken);
    const decodedRoles = getUserRolesFromToken(newToken);
    setRoles(decodedRoles);
    
    // Optionally, extract organizationId from token if it's stored there
    const orgId = getOrganizationIdFromToken(newToken);
    if (orgId) {
      updateOrganizationId(orgId);
    }
  };

  const updateOrganizationId = (id) => {
    setOrganizationId(id);
    localStorage.setItem("organizationId", id.toString());
  };

  const updateUserId = (id) => {
    setUserId(id);
    localStorage.setItem("userId", id.toString());
  };

  const updateEmailAddress = (emailAddress) => {
    setEmailAddress(emailAddress);
    localStorage.setItem("emailAddress", emailAddress.toString());
  };

  const updateFirstName = (firstName) => {
    setFirstName(firstName);
    localStorage.setItem("firstName", firstName.toString());
  };
  const updateLastName = (lastName) => {
    setLastName(lastName);
    localStorage.setItem("lastName", lastName.toString());
  };

  const updateContactNumber = (contactNumber) => {
    setContactNumber(contactNumber);
    localStorage.setItem("contactNumber", contactNumber.toString());
  }

  useEffect(() => {
    const savedToken = localStorage.getItem("jwtToken");
    const savedOrgId = localStorage.getItem("organizationId");
    const savedUserId = localStorage.getItem("userId");
    const savedLastName = localStorage.getItem("lastName");
    const savedFirstName = localStorage.getItem("firstName");
    const savedEmailAddress = localStorage.getItem("emailAddress");

    if (savedToken) {
      setToken(savedToken);
      const decodedRoles = getUserRolesFromToken(savedToken);
      setRoles(decodedRoles);
    }

    if (savedOrgId) {
      setOrganizationId(parseInt(savedOrgId, 10));
    }

    if (savedUserId) {
      setUserId(parseInt(savedUserId, 10));
    }

    if(savedFirstName) {
      setFirstName(savedFirstName);
    }
    if(savedLastName){
      setLastName(savedLastName);
    }
    if(savedEmailAddress){
      setEmailAddress(savedEmailAddress);
    }
  }, []);

  const logout = () => {
    setToken(null);
    setRoles([]);
    setOrganizationId(0);
    setUserId(0);
    setEmailAddress(null);
    setFirstName(null);
    setLastName(null);
    setContactNumber(null);
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("organizationId");
    localStorage.removeItem("userId");
    localStorage.removeItem("emailAddress");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("contactNumber");
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        roles,
        organizationId,
        userId,
        emailAddress,
        firstName,
        lastName,
        contactNumber, 
        updateToken,
        updateOrganizationId,
        updateUserId,
        updateEmailAddress,
        updateLastName,
        updateFirstName,
        updateContactNumber,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);